// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AnyFunction = (...args: any[]) => any;

type FunctionLike<TFunction extends AnyFunction> = (
  ...args: Parameters<TFunction>
) => ReturnType<TFunction>;

/**
 * Decorator function which evaluates a list of predicate functions to
 * determine if the decorated function should be executed, otherwise a
 * default value is returned.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const predicate = <TFunction extends AnyFunction>(
  fn: TFunction,
  predicates: Array<(...args: Parameters<TFunction>) => boolean>,
  defaultVal: ReturnType<TFunction>,
): FunctionLike<TFunction> => {
  return (...args: Parameters<TFunction>): ReturnType<TFunction> => {
    const shouldExecute = predicates.every((p) => p(...args));

    if (shouldExecute) {
      return fn(...args);
    }

    return defaultVal;
  };
};

/**
 * Future person: this function has been re-exported by packages/subscription-management.
 * If you extract this out of webapp into a standalone util please inform `@hotjar/monetization-platform` or `@hotjar/billing` FE so they are aware
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noop(): void {}

export function is<T>(a: T) {
  return (b: T): boolean => a === b;
}
